<template>
  <div id="app-manage-members" class="account__article" style="display: none;">
    <h2 class="mb-3 text-3xl text-ma-black-1 font-light mb-4">
      Manage Members
    </h2>
    <div
      id="content-header"
      class="w-full px-4 h-32 md:h-16 flex flex-col md:flex-row md:justify-between items-center bg-ma-gray-11"
    >
      <ul
        id="content-tabs"
        class="flex justify-center h-12 md:h-full pt-2 pl-0 md:justify-start md:p-0 m-0"
      >
        <li
          v-for="(tab, index) in tabs"
          :key="index"
          class="tab uppercase box-content text-ma-black-1 opacity-50 min-w-48 text-center h-10 md:h-full font-bold text-xs flex justify-center items-center cursor-pointer transition-colors duration-200 hover:opacity-100"
          :class="
            tab.id === selectedCategory
              ? 'active opacity-100 border-b-2 border-ma-black-1'
              : ''
          "
          @click="onSelectTab(tab.id)"
        >
          {{ tab.name }}&nbsp;
          <span>({{ categoryMembersCount(tab.id) }})</span>
        </li>
      </ul>
      <div
        class="search-box w-full md:w-1/2 lg:w-1/3 flex relative mt-8 md:mt-0 "
      >
        <i
          class="icon--search absolute cursor-pointer text-ma-gray-3 right-0 top-0 mt-2 mr-3"
          @click="onSearch"
        ></i>
        <input
          id="search-input"
          autocapitalize="off"
          autocomplete="off"
          autocorrect="off"
          type="search"
          class="h-4 w-full bg-white pl-4 pr-8 py-2 text-base outline-none"
          placeholder="Search members"
          :value="query"
          @input="onInputSearch"
          @keyup.enter="onSearch"
          ref="searchInput"
        />
      </div>
    </div>
    <div id="content-body" class="p-2 w-full bg-white">
      <div class="w-full flex justify-between pb-4 pt-2 px-2">
        <div
          class="text-xs text-[#534cda] uppercase font-bold cursor-pointer px-2 py-1"
          @click="modalVisible.add_additional_members = true"
        >
          Add Members
        </div>
        <div class="text-xs text-ma-black-1 uppercase font-bold py-1">
          {{ myTeam && myTeam.seats && myTeam.seats.empty }} Empty Seats
        </div>
      </div>
      <div id="members-container" class="w-full flex flex-wrap">
        <template v-for="member in selectedCategoryMembers">
          <div class="w-full md:w-1/2 lg:w-1/3 p-2" :key="member.id">
            <MemberCard
              :member="member"
              :menuVisible="currentMember && member.id == currentMember.id && editMenuVisible"
              @openMenu="onEditMember(member)"
              @clickItem="onClickEditItem"
            />
          </div>
        </template>
      </div>
    </div>
    <AddAdditionalMembersModal
      v-if="modalVisible.add_additional_members"
      @close="onCloseModal()"
      @updated="onUpdated()"
      :loading="loading.add_additional_members"
    />

    <ConfirmModal
      v-if="currentAction && currentAction.id && modalVisible.confirm"
      @close="onCloseModal()"
      @confirm="confirmAction()"
      :title="
        editMenu[currentAction.id].confirm && editMenu[currentAction.id].confirm.title
      "
      :description="
        editMenu[currentAction.id].confirm &&
          editMenu[currentAction.id].confirm.description
      "
      :yes="
        editMenu[currentAction.id].confirm && editMenu[currentAction.id].confirm.yes
      "
      :no="
        editMenu[currentAction.id].confirm && editMenu[currentAction.id].confirm.no
      "
      :name="currentMember.email"
    />
  </div>
</template>

<script>
/* constants */
import { TEAM_MANAGER_TABS, TEAM_MANAGER_EDIT_MENU } from "@/constants";

/* components */
import MemberCard from "./components/MemberCard";
import ConfirmModal from "./components/ConfirmModal";
import AddAdditionalMembersModal from "./components/AddAdditionalMembersModal";
import RemoveFromTeamModal from "./components/RemoveFromTeamModal";

/* vuex */
import { mapState, mapGetters } from "vuex";

export default {
  components: {
    MemberCard,
    ConfirmModal,
    AddAdditionalMembersModal,
  },
  data: () => ({
    /* constants */
    tabs: TEAM_MANAGER_TABS,
    editMenu: TEAM_MANAGER_EDIT_MENU,

    /* main */
    currentMember: null,
    currentAction: null,
    itemsPerPage: 15,

    /* misc */
    clickEventHandler: null,
    editMenuVisible: false,
    modalVisible: {
      add_additional_members: false,
      confirm: false,
    },
    loading: {
      add_additional_members: false,
      allocate_seat: false,
      remove_member: false,
      make_admin: false,
    },
  }),
  computed: {
    ...mapState({
      selectedCategory: (state) => state.teamManagement.selectedCategory,
      query: (state) => state.teamManagement.query,
    }),
    ...mapGetters({
      activeMembers: "teamManagement/activeMembers",
      activeAdminMembers: "teamManagement/activeAdminMembers",
      pendingMembers: "teamManagement/pendingMembers",
      selectedCategoryMembers: "teamManagement/selectedCategoryMembers",
      categoryMembersCount: "teamManagement/categoryMembersCount",
      myTeam: "teamManagement/myTeam",
    }),
    result() {
      return this.results[this.tabIndex];
    },
  },
  metaInfo: () => ({
    title: "Team Manage Members | Motion Array",
    link: [{ rel: "stylesheet", href: "/assets/site/css/team.css" }],
  }),
  mounted() {
    document.querySelector('.account-links__container').parentElement.appendChild(this.$el)
    this.$el.style.display = null
    if (!this.clickEventHandler) {
      this.clickEventHandler = document.addEventListener(
        "click",
        this.onClickDocument
      );
    }

    this.onSearch();
    this.getMyTeam();
  },
  beforeDestroy() {
    if (this.clickEventHandler) {
      document.removeEventListener("click", this.onClickDocument);
      this.clickEventHandler = undefined;
    }
  },
  methods: {
    onSelectTab(category) {
      this.$store.dispatch("teamManagement/setSelectedCategory", category);
    },
    onInputSearch(e) {
      this.$store.dispatch("teamManagement/setQuery", e.target.value);
    },
    getMyTeam() {
      const data = this.$store.dispatch("teamManagement/getMyTeam");
    },
    onSearch() {
      this.$store.dispatch("teamManagement/getMembers");
    },
    onUpdated() {
      this.onCloseModal();
    },
    onEditMember(member) {
      this.currentMember = member;
      this.editMenuVisible = !this.editMenuVisible;
    },
    onClickDocument(event) {
      let isOutside = true;
      if (event.path) {
        event.path.forEach((element) => {
          if (
                  element &&
                  element.classList &&
                  element.classList.contains("member-edit-menu")
          ) {
            isOutside = false;
          }
        });
      }

      if (event.target.closest('.member-edit-menu')) {
        isOutside = false;
      }
      if (isOutside) {
        this.editMenuVisible = false;
      }
    },
    onShowMore() {},
    onClickEditItem(action) {
      this.editMenuVisible = false;
      const menuId = Object.keys(TEAM_MANAGER_EDIT_MENU)
        .map(k => TEAM_MANAGER_EDIT_MENU[k])
        .find(e => e.name === action.label).id;
      this.currentAction = {
        item: action.item,
        label: action.label,
        id: menuId,
      };
      if (TEAM_MANAGER_EDIT_MENU[menuId].confirm) {
        this.modalVisible.confirm = true;
      } else {
        this.confirmAction();
      }
    },
    onCloseModal(id) {
      if (id) {
        this.modalVisible[id] = false;
      } else {
        Object.keys(this.modalVisible).forEach((key) => {
          this.modalVisible[key] = false;
        });
      }
    },
    async confirmAction() {
      try {
        console.log(this.currentMember, this.currentAction)
        this.modalVisible["confirm"] = false;
        this.loading[this.currentAction.id] = true;
        const result = await this.$store.dispatch(
          `teamManagement/editAction`,
          this.currentAction.item
        );
        this.loading[this.currentAction.id] = false;
      } catch (err) {
        this.loading[this.currentAction.id] = false;
        // TODO: error handler
      }
    },
  },
};
</script>

<style scoped>
#content-tabs > .tab {
  width: 111px;
  max-width: 30vw;
}

#app-manage-members .modal-container {
  width: 90%;
  max-width: 900px;
}
.text-\[\#534cda\] {
  color: #534cda;
}
</style>
